import InitApp from "./screens/InitApp";
import Forbidden from "./screens/Forbidden";
import NotStudent from "./screens/NotStudent";
import NotFound from "./screens/NotFound";
import Desktop from "./screens/Desktop";
import Inscriptions from "./screens/inscriptions/inscriptions";
import Inscription from "./screens/inscriptions/inscription";
import Contacts from "./screens/Contacts";
import Examens from "./screens/evenements/examens";
import Commandes from "./screens/commandes/commandes";
import NouvelleCommande from "./screens/commandes/nouvelleCommande";
import Memoire from "./screens/memoires/memoire";
import Consentement from "./screens/memoires/consentement";
import RemiseMemoire from "./screens/memoires/remise";
import screens from "./screens";
import BlockedStudent from "./screens/BlockedStudent";
import InactiveStudent from "./screens/InactiveStudent";
import Stages from "./screens/evenements/stages";
import Reinscription from "./screens/reinscription/reinscription";
import PAE from "./screens/reinscription/PAE";
import FicheDescriptive from "./screens/reinscription/ficheDescriptive";
import SignaturePAE from "./screens/reinscription/signaturePAE";
import Valves from "./screens/Valves";
import TP from "./screens/evenements/TP";
import DecretInclusif from "./screens/inclusif/decretInclusif";
import Documents from "./screens/documents/documents";
import Verifications from "./screens/verifications/verifications";
import SignaturePAI from "./screens/inclusif/signaturePAI";
import Absences from "./screens/absences/absences";
import Absence from "./screens/absences/absence";
import Remediations from "./screens/sar/remediations";
import IDM from "./screens/memoires/IDM";
import Proclamation from "./screens/evenements/proclamation";

export default [
    {
        path: `${process.env.APP_ROOT}`,
        first: true,
        exact: true,
        label: "Home",
        component: InitApp,
        routes: [
            {
                path: "/desktop",
                title: "Bureau virtuel",
                showUser: true,
                label: "Desktop",
                component: Desktop,
                screen: screens.Dashboard,
                routes: []
            },
            {
                path: "/valves",
                title: "Valves électroniques",
                label: "Valves",
                component: Valves,
                screen: screens.Valves,
                routes: []
            },
            {
                path: "/contacts",
                title: "Mes données",
                label: "Informations de contact",
                component: Contacts,
                screen: screens.Contacts,
                routes: []
            },
            {
                path: "/ficheUE/:id",
                title: "Fiche descriptive d'une unité d'enseignement",
                label: "Fiche descriptive d'une unité d'enseignement",
                component: FicheDescriptive,
                screen: screens.UEDetail,
                routes: []
            },
            {
                path: "/inscriptions",
                title: "Mes inscriptions",
                label: "Inscriptions",
                component: Inscriptions,
                screen: screens.Inscriptions,
                routes: [
                    {
                        path: "/:id",
                        label: "Détail de l'inscription",
                        component: Inscription,
                        screen: screens.Inscription,
                        routes: []
                    },
                ]
            },
            {
                path: "/absences",
                title: "Mes absences",
                label: "Absences",
                component: Absences,
                screen: screens.Absences,
                routes: [
                    {
                        path: "/:id",
                        label: "Détail de l'absence",
                        component: Absence,
                        screen: screens.Absence,
                        routes: []
                    },
                ]
            },
            {
                path: "/commandes",
                label: "Commandes",
                title: "Mes commandes",
                component: Commandes,
                screen: screens.Commandes,
                routes: [
                    {
                        path: "/new",
                        label: "Nouvelle commande",
                        component: NouvelleCommande,
                        screen: screens.NouvelleCommande,
                        routes: []
                    },
                ]
            },
            {
                path: "/documents",
                label: "Documents",
                title: "Mes documents",
                component: Documents,
                screen: screens.Documents,
                routes: []
            },
            {
                path: "/sar",
                label: "SAR / Remédiations",
                title: "SAR - Remédiations",
                component: Remediations,
                screen: screens.SAR,
                routes: []
            }, {
                path: "/memoire",
                label: "Mémoire",
                title: "Mon mémoire",
                component: Memoire,
                screen: screens.Memoire,
                routes: [
                    {
                        path: "/consentement",
                        label: "Consentement",
                        component: Consentement,
                        screen: screens.Consentement,
                        routes: []
                    }, {
                        path: "/remise",
                        label: "Remise",
                        component: RemiseMemoire,
                        screen: screens.RemiseMemoire,
                        routes: []
                    },
                    {
                        path: "/IDM",
                        title: "Informations relatives à la Défense du Mémoire",
                        label: "Informations relatives à la Défense du Mémoire",
                        component: IDM,
                        screen: screens.InformationsRelativesDefenseMemoire,
                        routes: []
                    },
                ]
            }, {
                path: "/evenement",
                label: "Événement",
                routes: [
                    {
                        path: "/reinscription",
                        title: "Réinscription",
                        label: "Inscription à une nouvelle année académique",
                        component: Reinscription,
                        screen: screens.Reinscription,
                        routes: [{
                            path: "/PAE",
                            label: "Programme annuel effectif",
                            component: PAE,
                            screen: screens.PAE,
                            routes: []
                        }]
                    }, {
                        path: "/signaturePAE",
                        title: "Signature du PAE",
                        label: "Signature du programme annuel effectif",
                        component: SignaturePAE,
                        screen: screens.SignaturePAE,
                        routes: []
                    }, {
                        path: "/inscriptionTP",
                        title: "Inscription aux TP",
                        label: "Inscription aux groupes de Travaux Pratiques",
                        component: TP,
                        screen: screens.InscriptionTP,
                        routes: []
                    }, {
                        path: "/inscriptionExamens",
                        label: "Inscription à la session d'examen",
                        component: Examens,
                        screen: screens.Examens,
                        routes: []
                    },             
                    {
                        path: "/proclamation",
                        label: "Inscription à la proclamation",
                        component: Proclamation,
                        screen: screens.Proclamation,
                        routes: []
                    }, 
                    {
                        path: "/stages",
                        label: "Stages",
                        title: "Mes stages",
                        component: Stages,
                        screen: screens.Stages,
                        routes: []
                    },
                ]
            },
            {
                path: "/enseignement-inclusif",
                title: "Enseignement inclusif",
                label: "Enseignement inclusif",
                component: DecretInclusif,
                screen: screens.DecretInclusif,
                routes: [
                    {
                        path: "/signature",
                        title: "Signature du PAI",
                        label: "Signature du Plan d'Accompagnement Individualisé",
                        component: SignaturePAI,
                        screen: screens.SignaturePAI,
                        routes: []
                    }
                ]
            },
            {
                path: "/verifications",
                title: "Espace Vérifications",
                label: "Vérifications",
                component: Verifications,
                screen: screens.Verifications,
                routes: []
            },
            {
                path: "/forbidden",
                label: "Interdit",
                component: Forbidden,
                routes: []
            },
            {
                path: "/blockedStudent",
                label: "Étudiant bloqué",
                component: BlockedStudent,
                routes: []
            },
            {
                path: "/inactiveStudent",
                label: "Étudiant inactif",
                component: InactiveStudent,
                routes: []
            },
            {
                path: "/notStudent",
                label: "Pas un étudiant",
                component: NotStudent,
                routes: []
            }
        ]
    },
    {
        path: "*",
        label: "",
        component: NotFound
    }
];